import { Button } from "@mui/material";

export const CopyGridToClipboard = ({ rows, columns }) => {
  const handleCopyToClipboard = () => {
    if (!rows.length) return;

    const header = columns.map((col) => col.headerName).join("\t");
    const data = rows
      .map((row) => columns.map((col) => row[col.field] ?? "").join("\t"))
      .join("\n");

    const fullText = `${header}\n${data}`;

    navigator.clipboard
      .writeText(fullText)
      .then(() => alert("Copied to clipboard"))
      .catch(() => alert("Failed to copy"));
  };
  return (
    <Button
      variant="contained"
      color="primary"
      sx={{ mt: 2 }}
      onClick={handleCopyToClipboard}
    >
      Copy to Clipboard
    </Button>
  );
};
